import useClient from 'common/hooks/useClient';
import usePersonnel from 'common/hooks/usePersonnel';

const useRiderChatEnabled = () => {
    const client = useClient();
    const personnel = usePersonnel();

    const { chatSettings } = client;

    return (
        chatSettings.enableRiderPersonnelChat && !personnel.isGlobalPersonnel()
    );
};

export default useRiderChatEnabled;
